import { Entry } from 'contentful';

export class ModelValidator {
  public static isBanner(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'banner';
  }

  public static isSection(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'section';
  }

  public static isTableSection(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'tableSection';
  }

  public static isCard(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'card';
  }

  public static isPage(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'page';
  }

  public static isNote(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'note';
  }

  public static isNdcProductUpdateNotification(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'ndcProductUpdateNotification';
  }

  public static isIagProductUpdateNotification(entry: Entry<any>): boolean {
    return entry.sys.contentType.sys.id === 'iagProductUpdateNotification';
  }
}
